import React from 'react';
import './GameEntry.css';

/**
 * Component for entering details of a single game
 * @param {Object} props
 * @param {number} props.gameNumber - Game number (1-7)
 * @param {Object} props.game - Current game data
 * @param {Function} props.onChange - Callback when game data changes
 * @param {Array} props.team1Players - Team 1 player options
 * @param {Array} props.team2Players - Team 2 player options
 */
export default function GameEntry({
  gameNumber,
  game,
  onChange,
  team1Players,
  team2Players,
}) {
  const handleFieldChange = (field, value) => {
    onChange({
      ...game,
      [field]: value,
    });
  };

  return (
    <div className="game-entry">
      <div className="game-header">
        <h4>Game {gameNumber}</h4>
        {game.winner && (
          <span className={`winner-badge winner-${game.winner}`}>
            {game.winner === 'team1' ? 'Team 1 Won' : 'Team 2 Won'}
          </span>
        )}
      </div>

      <div className="game-grid">
        <div className="player-selection">
          <label htmlFor={`game-${gameNumber}-team1-player`}>
            Team 1 Player *
          </label>
          <select
            id={`game-${gameNumber}-team1-player`}
            value={game.team1PlayerId || ''}
            onChange={(e) => handleFieldChange('team1PlayerId', e.target.value)}
            required
          >
            <option value="">Select player...</option>
            {team1Players.map((player) => (
              <option key={player.playerId} value={player.playerId}>
                {player.name}
              </option>
            ))}
          </select>
        </div>

        <div className="player-selection">
          <label htmlFor={`game-${gameNumber}-team2-player`}>
            Team 2 Player *
          </label>
          <select
            id={`game-${gameNumber}-team2-player`}
            value={game.team2PlayerId || ''}
            onChange={(e) => handleFieldChange('team2PlayerId', e.target.value)}
            required
          >
            <option value="">Select player...</option>
            {team2Players.map((player) => (
              <option key={player.playerId} value={player.playerId}>
                {player.name}
              </option>
            ))}
          </select>
        </div>

        <div className="game-details">
          <label htmlFor={`game-${gameNumber}-lag-winner`}>Lag Winner *</label>
          <select
            id={`game-${gameNumber}-lag-winner`}
            value={game.lagWinner || ''}
            onChange={(e) => handleFieldChange('lagWinner', e.target.value)}
            required
          >
            <option value="">Select...</option>
            <option value="team1">Team 1</option>
            <option value="team2">Team 2</option>
          </select>
        </div>

        <div className="game-details">
          <label htmlFor={`game-${gameNumber}-breaker`}>Breaker *</label>
          <select
            id={`game-${gameNumber}-breaker`}
            value={game.breaker || ''}
            onChange={(e) => handleFieldChange('breaker', e.target.value)}
            required
          >
            <option value="">Select...</option>
            <option value="team1">Team 1</option>
            <option value="team2">Team 2</option>
          </select>
        </div>

        <div className="game-details winner-selection">
          <label htmlFor={`game-${gameNumber}-winner`}>Winner *</label>
          <select
            id={`game-${gameNumber}-winner`}
            value={game.winner || ''}
            onChange={(e) => handleFieldChange('winner', e.target.value)}
            required
          >
            <option value="">Select...</option>
            <option value="team1">Team 1</option>
            <option value="team2">Team 2</option>
          </select>
        </div>
      </div>
    </div>
  );
}
